<script>
import { Header as AppHeader, SidebarToggler } from '@coreui/vue'
import { infoComputed, filtersComputed } from '@state/helpers'

export default {
  components: {
    AppHeader,
    SidebarToggler,
  },

  computed: {
    ...infoComputed,
    ...filtersComputed,
  },
}
</script>

<template>
  <AppHeader v-once fixed>
    <SidebarToggler class="d-lg-none" display="md" mobile />

    <b-link class="navbar-brand" to="/#/device/state">
      <img
        class="navbar-brand-full"
        src="@assets/images/logo.png"
        width="65"
        height="32"
        alt="Open Industry"
      />
      <img
        class="navbar-brand-minimized"
        src="@assets/images/compactLogogray.png"
        width="24"
        height="20"
        alt="Open Industry"
      />
    </b-link>
    <a
      href="https://wri.thing.events/"
      target="_blank"
      style="text-decoration: none; color:#fff;"
      v-show="$route.path === '/insights/explorer'"
    >
      <samp class="text-truncate" style="max-width: 350px; cursor: pointer;">
        https://wri.thing.events/
      </samp>
    </a>
    <SidebarToggler style="display:none" class="d-md-down-none" display="lg" />
    <!-- <span
      v-if="dateRangeReadableFilters"
      class="text-uppercase font-weight-bold breadcrumb-info pl-3"
    >
      {{ dateRangeReadableFilters }}
    </span>-->
    <b-navbar-nav class="ml-auto">
      <BaseInfoToggler v-if="enabled" :class="'info-toggle'" class="d-none d-lg-block" />
      <BaseInfoToggler v-if="enabled" :class="'info-toggle'" class="d-lg-none" mobile />
      <BaseNavBarFullscreen :class="'info-toggle'" />
    </b-navbar-nav>
  </AppHeader>
</template>

<style lang="scss">
.info-toggle {
  font-size: 1.3rem !important;
}
</style>
